//
//    WARNING
//    This file was auto-generated by swagger-typescript-codegen.
//    Please do not make changes here because they may be overwritten.
//

import request from 'superagent';
import { SuperAgentStatic, SuperAgentRequest, Response } from 'superagent';
import {
  CallbackHandler,
  RequestHeadersHandler,
  ConfigureAgentHandler,
  ConfigureRequestHandler,
  Logger,
  RequestHeaders,
  QueryParameters,
  CommonRequestOptions,
  ResponseWithBody,
} from './types';

export type JToken = Array<JToken>;

export type ProblemDetails = {
  detail?: string;
  instance?: string;
  status?: number;
  title?: string;
  type?: string;
} & {
  [key: string]: {} & {
    [key: string]: any;
  };
};

export type PropertyClause = {
  operator?: string;
  value?: void;
};

export type QueryPayload = {
  document?: {} & {
    [key: string]: Array<PropertyClause>;
  };
  page?: number;
  pageSize?: number;
  sortBy?: string;
  sortOrder?: string;
};

/**
 * Insight2Profit Document Service
 * @class DocumentService
 * @param {(string)} [domainOrOptions] - The project domain.
 */
export class DocumentService {
  private domain: string = '';
  private errorHandlers: CallbackHandler[] = [];
  private requestHeadersHandler?: RequestHeadersHandler;
  private configureAgentHandler?: ConfigureAgentHandler;
  private configureRequestHandler?: ConfigureRequestHandler;

  constructor(domain?: string, private logger?: Logger) {
    if (domain) {
      this.domain = domain;
    }
  }

  getDomain() {
    return this.domain;
  }

  addErrorHandler(handler: CallbackHandler) {
    this.errorHandlers.push(handler);
  }

  setRequestHeadersHandler(handler: RequestHeadersHandler) {
    this.requestHeadersHandler = handler;
  }

  setConfigureAgentHandler(handler: ConfigureAgentHandler) {
    this.configureAgentHandler = handler;
  }

  setConfigureRequestHandler(handler: ConfigureRequestHandler) {
    this.configureRequestHandler = handler;
  }

  private request(
    method: string,
    url: string,
    body: any,
    headers: RequestHeaders,
    queryParameters: QueryParameters,
    form: any,
    reject: CallbackHandler,
    resolve: CallbackHandler,
    opts: CommonRequestOptions
  ) {
    if (this.logger) {
      this.logger.log(`Call ${method} ${url}`);
    }

    const agent = this.configureAgentHandler ? this.configureAgentHandler(request) : request;

    let req = agent(method, url);
    if (this.configureRequestHandler) {
      req = this.configureRequestHandler(req);
    }

    req = req.query(queryParameters);

    if (body) {
      req.send(body);

      if (typeof body === 'object' && !(body.constructor.name === 'Buffer')) {
        headers['Content-Type'] = 'application/json';
      }
    }

    headers['x-insight-ns'] = 'master';

    if (Object.keys(form).length > 0) {
      req.type('form');
      req.send(form);
    }

    if (this.requestHeadersHandler) {
      headers = this.requestHeadersHandler({
        ...headers,
      });
    }

    req.set(headers);

    if (opts.$retries && opts.$retries > 0) {
      req.retry(opts.$retries);
    }

    if ((opts.$timeout && opts.$timeout > 0) || (opts.$deadline && opts.$deadline > 0)) {
      req.timeout({
        deadline: opts.$deadline,
        response: opts.$timeout,
      });
    }

    req.end((error, response) => {
      // an error will also be emitted for a 4xx and 5xx status code
      // the error object will then have error.status and error.response fields
      // see superagent error handling: https://github.com/visionmedia/superagent/blob/master/docs/index.md#error-handling
      if (error) {
        reject(error);
        this.errorHandlers.forEach((handler) => handler(error));
      } else {
        resolve(response);
      }
    });
  }

  /**
   *
   * @method
   * @name DocumentService#getDocsClientsByClientIdTypesByDocumentType
   * @description /docs/clients/{clientId}/types/{documentType}
   * @param {string} clientId - Insight2Profit Document Service
   * @param {string} documentType - Insight2Profit Document Service
   * @param {string} sortBy - Insight2Profit Document Service
   * @param {string} sortOrder - Insight2Profit Document Service
   * @param {integer} pageSize - Insight2Profit Document Service
   * @param {integer} page - Insight2Profit Document Service
   */
  getDocsClientsByClientIdTypesByDocumentType(
    parameters: {
      clientId: string;
      documentType: string;
      sortBy?: string;
      sortOrder?: string;
      pageSize?: number;
      page?: number;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, void>
    | ResponseWithBody<401, ProblemDetails>
    | ResponseWithBody<403, ProblemDetails>
    | ResponseWithBody<500, void>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/docs/clients/{clientId}/types/{documentType}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{documentType}', `${parameters['documentType']}`);

      if (parameters['documentType'] === undefined) {
        reject(new Error('Missing required  parameter: documentType'));
        return;
      }

      if (parameters['sortBy'] !== undefined) {
        queryParameters['sortBy'] = parameters['sortBy'];
      }

      if (parameters['sortOrder'] !== undefined) {
        queryParameters['sortOrder'] = parameters['sortOrder'];
      }

      if (parameters['pageSize'] !== undefined) {
        queryParameters['pageSize'] = parameters['pageSize'];
      }

      if (parameters['page'] !== undefined) {
        queryParameters['page'] = parameters['page'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name DocumentService#postDocsClientsByClientIdTypesByDocumentType
   * @description /docs/clients/{clientId}/types/{documentType}
   * @param {string} clientId - Insight2Profit Document Service
   * @param {string} documentType - Insight2Profit Document Service
   * @param {} body - Insight2Profit Document Service
   */
  postDocsClientsByClientIdTypesByDocumentType(
    parameters: {
      clientId: string;
      documentType: string;
      body?: Array<JToken>;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, void>
    | ResponseWithBody<401, ProblemDetails>
    | ResponseWithBody<403, ProblemDetails>
    | ResponseWithBody<429, ProblemDetails>
    | ResponseWithBody<500, void>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/docs/clients/{clientId}/types/{documentType}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{documentType}', `${parameters['documentType']}`);

      if (parameters['documentType'] === undefined) {
        reject(new Error('Missing required  parameter: documentType'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      form = queryParameters;
      queryParameters = {};

      this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name DocumentService#postDocsClientsByClientIdTypesByDocumentTypeQuery
   * @description /docs/clients/{clientId}/types/{documentType}/query
   * @param {string} clientId - Insight2Profit Document Service
   * @param {string} documentType - Insight2Profit Document Service
   * @param {} body - Insight2Profit Document Service
   */
  postDocsClientsByClientIdTypesByDocumentTypeQuery(
    parameters: {
      clientId: string;
      documentType: string;
      body?: QueryPayload;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, void>
    | ResponseWithBody<401, ProblemDetails>
    | ResponseWithBody<403, ProblemDetails>
    | ResponseWithBody<500, void>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/docs/clients/{clientId}/types/{documentType}/query';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{documentType}', `${parameters['documentType']}`);

      if (parameters['documentType'] === undefined) {
        reject(new Error('Missing required  parameter: documentType'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      form = queryParameters;
      queryParameters = {};

      this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name DocumentService#deleteDocsClientsByClientIdTypesByDocumentTypeByDocumentId
   * @description /docs/clients/{clientId}/types/{documentType}/{documentId}
   * @param {string} clientId - Insight2Profit Document Service
   * @param {string} documentType - Insight2Profit Document Service
   * @param {string} documentId - Insight2Profit Document Service
   */
  deleteDocsClientsByClientIdTypesByDocumentTypeByDocumentId(
    parameters: {
      clientId: string;
      documentType: string;
      documentId: string;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, void>
    | ResponseWithBody<401, ProblemDetails>
    | ResponseWithBody<403, ProblemDetails>
    | ResponseWithBody<404, ProblemDetails>
    | ResponseWithBody<500, void>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/docs/clients/{clientId}/types/{documentType}/{documentId}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{documentType}', `${parameters['documentType']}`);

      if (parameters['documentType'] === undefined) {
        reject(new Error('Missing required  parameter: documentType'));
        return;
      }

      path = path.replace('{documentId}', `${parameters['documentId']}`);

      if (parameters['documentId'] === undefined) {
        reject(new Error('Missing required  parameter: documentId'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('DELETE', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name DocumentService#getDocsClientsByClientIdTypesByDocumentTypeByDocumentId
   * @description /docs/clients/{clientId}/types/{documentType}/{documentId}
   * @param {string} clientId - Insight2Profit Document Service
   * @param {string} documentType - Insight2Profit Document Service
   * @param {string} documentId - Insight2Profit Document Service
   */
  getDocsClientsByClientIdTypesByDocumentTypeByDocumentId(
    parameters: {
      clientId: string;
      documentType: string;
      documentId: string;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, void>
    | ResponseWithBody<401, ProblemDetails>
    | ResponseWithBody<403, ProblemDetails>
    | ResponseWithBody<404, ProblemDetails>
    | ResponseWithBody<500, void>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/docs/clients/{clientId}/types/{documentType}/{documentId}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{documentType}', `${parameters['documentType']}`);

      if (parameters['documentType'] === undefined) {
        reject(new Error('Missing required  parameter: documentType'));
        return;
      }

      path = path.replace('{documentId}', `${parameters['documentId']}`);

      if (parameters['documentId'] === undefined) {
        reject(new Error('Missing required  parameter: documentId'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name DocumentService#putDocsClientsByClientIdTypesByDocumentTypeByDocumentId
   * @description /docs/clients/{clientId}/types/{documentType}/{documentId}
   * @param {string} clientId - Insight2Profit Document Service
   * @param {string} documentType - Insight2Profit Document Service
   * @param {string} documentId - Insight2Profit Document Service
   * @param {} body - Insight2Profit Document Service
   */
  putDocsClientsByClientIdTypesByDocumentTypeByDocumentId(
    parameters: {
      clientId: string;
      documentType: string;
      documentId: string;
      body?: {} & {
        [key: string]: JToken;
      };
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, void>
    | ResponseWithBody<401, ProblemDetails>
    | ResponseWithBody<403, ProblemDetails>
    | ResponseWithBody<404, ProblemDetails>
    | ResponseWithBody<500, void>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/docs/clients/{clientId}/types/{documentType}/{documentId}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{documentType}', `${parameters['documentType']}`);

      if (parameters['documentType'] === undefined) {
        reject(new Error('Missing required  parameter: documentType'));
        return;
      }

      path = path.replace('{documentId}', `${parameters['documentId']}`);

      if (parameters['documentId'] === undefined) {
        reject(new Error('Missing required  parameter: documentId'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('PUT', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }
}

export default DocumentService;
